import React from 'react';
import { motion } from 'framer-motion';
import { SearchBar } from './SearchBar';
interface HeroSectionProps {
  onSearch?: () => void;
}
export function HeroSection({
  onSearch
}: HeroSectionProps) {
  return <div className="relative" data-id="element-198">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-199">
        <img src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1920&q=80" alt="Luxury beach destination" className="w-full h-full object-cover" data-id="element-200" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/40" data-id="element-201"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-40 pb-32 md:pt-48 md:pb-40 flex flex-col items-center text-center" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto mb-12 md:mb-16" data-id="element-203">
          <h1 className="text-5xl md:text-7xl font-italiana text-white mb-6 leading-tight drop-shadow-lg" data-id="element-204">
            Discover Your Next <br className="hidden md:block" data-id="element-205" /> Luxury Escape
          </h1>
          <p className="text-lg md:text-xl text-white/90 font-poppins font-light max-w-2xl mx-auto drop-shadow-md" data-id="element-206">
            Handpicked hotels, villas & apartments in the world's most beautiful
            destinations
          </p>
        </motion.div>

        {/* Search Bar - anchored inside the hero */}
        <SearchBar onSearch={onSearch} data-id="element-207" />
      </div>
    </div>;
}